import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsIsoDateTime, parseAsString, useQueryStates } from 'nuqs';

export function useQSetUsageReportSearchParams() {
  const [
    { page, pageSize, examStartDate, examEndDate, examCourseId },
    setQSetUsageReportSearchParams,
  ] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    examStartDate: parseAsIsoDateTime,
    examEndDate: parseAsIsoDateTime,
    examCourseId: parseAsString,
  });

  const changePageNumber = (page: number) => {
    setQSetUsageReportSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQSetUsageReportSearchParams({ pageSize, page: 0 });
  };

  const changeFilters = (filters?: {
    examStartDate: Date | null;
    examEndDate: Date | null;
    examCourseId: string | null;
  }) => {
    setQSetUsageReportSearchParams({ ...filters, page: 0 });
  };

  return [
    { page, pageSize, examStartDate, examEndDate, examCourseId },
    {
      changePageNumber,
      changePageSize,
      changeFilters,
    },
  ] as const;
}
